import { render, staticRenderFns } from "./ResourceSeatingCapacity.vue?vue&type=template&id=f8bb3704&scoped=true"
import script from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
export * from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
import style0 from "./ResourceSeatingCapacity.vue?vue&type=style&index=0&id=f8bb3704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb3704",
  null
  
)

export default component.exports